import useLoad from 'components/hooks/useLoad';
import {integrityChoice} from 'constants/url';

function useLoadIntegrityChoice(selection: any) {
  return useLoad(integrityChoice, 'revision', {values: selection});
}

export default useLoadIntegrityChoice;
